export default "__VITE_ASSET__DpqbIAZf__"